import { Dialog, DialogBody, DialogContent } from '@src/design-system/dialog';
import { FiltersPopoverContent } from '../filter-popover-content/filter-popover-content';
import { FilterModalFooter } from './filter-modal-footer';
import { FilterModalHeader } from './filter-modal-header';

export function FilterModal({
  open,
  onOpenChange,
  onMinimize,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onMinimize: () => void;
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent
        align='right'
        className='flex max-h-[calc(100vh-48px)] flex-col p-0'
      >
        <FilterModalHeader onMinimize={onMinimize} />

        <DialogBody className='min-h-0 flex-1 p-6'>
          <FiltersPopoverContent />
        </DialogBody>

        <FilterModalFooter />
      </DialogContent>
    </Dialog>
  );
}
